import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { getFormattedEventDateTime } from "../../helper";
import Button from "../Button";
import Chip from "../Chip";
import ActionImageButton from "../DataTable/ActionImageButton";
import { getFormattedDate } from "../getFormattedDate";
import ListWithPagination from "../ListsWithPagination";
import { TableWithPagination } from "../TableWithPagination";

interface Props {
  data: {
    id: number;
    events_name: string;
    events_id: string;
    onboard_date: string;
    status: boolean;
  }[];
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  isTableDataLoading: boolean;
  onPageChange: (page: number) => void;
  onEdit: (id: string) => void;
  showAttendees: (events: {}) => void;
}

const EventsTable = ({
  data,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
  onEdit,
  showAttendees,
}: Props) => {
  const formattedCreatedOn = (createdAt: any) => {
    return (
      <DateAndTimeWrapper>
        <div>{getFormattedDate(createdAt, "YYYY-MM-DD")}</div>
        <div>{getFormattedDate(createdAt, "HH:mm")}</div>
      </DateAndTimeWrapper>
    );
  };
  
  const columns = [
    {
      path: "title",
      label: "Event Title",
      content: (event: any) => <TitleWrapper>{event.title}</TitleWrapper>,
    },
    {
      path: "createdAt",
      label: "Created on",
      content: (event: any) => formattedCreatedOn(event.createdAt),
    },
    {
      path: "location",
      label: "Location",
    },
    {
      path: "date",
      label: "Event Date & Time",
      content: (event: any) => (
        <DateAndTimeWrapper>
          <div>{getFormattedEventDateTime(event.date, event.time)}</div>
          <div>{getFormattedEventDateTime(event.endDate, event.endTime)}</div>
        </DateAndTimeWrapper>
      ),
    },
    {
      path: "phone",
      label: "Contact",
    },
    {
      path: "isNotificationEnabled",
      label: "Notification",
      content: (event: {
        id: number | string;
        isNotificationEnabled: boolean;
      }) => <div>{event.isNotificationEnabled ? "Enabled" : "Disabled"}</div>,
    },
    {
      key: "status",
      label: "Status",
      content: (event: { id: number | string; isInactive: boolean }) => (
        <Chip
          label={event.isInactive ? "Inactive" : "Active"}
          variant={event.isInactive ? "error" : "success"}
        />
      ),
    },
    {
      path: "attendees",
      label: "Attendees",
      content: (events: { id: number | string | any }) => (
        <Button
          variant="filled"
          label="View Results"
          color={Colors.red}
          onClick={() => showAttendees(events)}
        ></Button>
      ),
    },
    {
      label: "Edit",
      key: "edit",
      content: (event: { _id: number | string | any }) => (
        <ActionImageButton
          onClick={() => onEdit(event._id)}
          iconPath={require("../../assets/images/edit-icon.png")}
          label={"Edit Event"}
        />
      ),
    },
  ];
  return (
    <>
      <TableWrapper>
        <TableWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Events Details"}
          onRowClick={undefined}
        />
      </ListWrapper>
    </>
  );
};

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;
const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const TitleWrapper = styled.div`
  font-size: 0.875rem;
  color: ${Colors.eastBay};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 170px;
`;

const DateAndTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export default EventsTable;
